export const OPERATOR_TYPES_CONFIG = [
  { key: '1', value: 'دائمی', icon: 'Mobile', iconColor: '#0F53ED' },
  { key: '2', value: 'اعتباری', icon: 'Receipt-bill', iconColor: '#0F53ED' },
  { key: '3', value: 'دیتا', icon: 'email', iconColor: '#0F53ED' },
];

export const OPERATOR_TYPES_CONFIG_WITH_TD_LTE = [
  { key: '1', value: 'دائمی', icon: 'Mobile', iconColor: '#0F53ED' },
  { key: '2', value: 'اعتباری', icon: 'Receipt-bill', iconColor: '#0F53ED' },
  { key: '3', value: 'دیتا', icon: 'Network', iconColor: '#0F53ED' },
  { key: '4', value: 'TD-LTE', icon: 'email', iconColor: '#0F53ED' },
];
